import type * as React from "react";

export const StatCard = ({
  title,
  value,
  unit,
  icon: Icon,
  id,
}: {
  title: string;
  value: string | number;
  unit?: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  id?: string;
}) => (
  <div
    className="border-border bg-background space-y-5 rounded-xl border p-6"
    id={id}
  >
    <div className="flex items-start justify-between">
      <p className="label text-foreground">{title}</p>
      <Icon className="text-foreground size-5" />
    </div>
    <div className="flex items-end gap-2">
      <p className="h2 text-foreground">{value}</p>
      {unit && <p className="text-foreground">{unit}</p>}
    </div>
  </div>
);
